(function () {
  if (window.QLSShippingCalculatorInitV125Loaded) return;
  window.QLSShippingCalculatorInitV125Loaded = true;

  var STORAGE_KEY = 'qls_shipping_estimator_zip';
  var NOMINATIM_REVERSE_ENDPOINT = 'https://nominatim.openstreetmap.org/reverse';

  var ZIP_STATE_RANGES = [
    [6, 9, 'Puerto Rico'],
    [10, 27, 'Massachusetts'],
    [28, 29, 'Rhode Island'],
    [30, 38, 'New Hampshire'],
    [39, 49, 'Maine'],
    [50, 59, 'Vermont'],
    [60, 69, 'Connecticut'],
    [70, 89, 'New Jersey'],
    [100, 149, 'New York'],
    [150, 196, 'Pennsylvania'],
    [197, 199, 'Delaware'],
    [200, 200, 'District of Columbia'],
    [201, 201, 'Virginia'],
    [202, 205, 'District of Columbia'],
    [206, 212, 'Maryland'],
    [220, 246, 'Virginia'],
    [247, 268, 'West Virginia'],
    [270, 289, 'North Carolina'],
    [290, 299, 'South Carolina'],
    [300, 319, 'Georgia'],
    [320, 339, 'Florida'],
    [341, 349, 'Florida'],
    [350, 352, 'Alabama'],
    [354, 369, 'Alabama'],
    [370, 385, 'Tennessee'],
    [386, 397, 'Mississippi'],
    [398, 399, 'Georgia'],
    [400, 427, 'Kentucky'],
    [430, 459, 'Ohio'],
    [460, 479, 'Indiana'],
    [480, 499, 'Michigan'],
    [500, 528, 'Iowa'],
    [530, 549, 'Wisconsin'],
    [550, 567, 'Minnesota'],
    [570, 577, 'South Dakota'],
    [580, 588, 'North Dakota'],
    [590, 599, 'Montana'],
    [600, 629, 'Illinois'],
    [630, 658, 'Missouri'],
    [660, 679, 'Kansas'],
    [680, 693, 'Nebraska'],
    [700, 715, 'Louisiana'],
    [716, 729, 'Arkansas'],
    [730, 749, 'Oklahoma'],
    [750, 799, 'Texas'],
    [800, 816, 'Colorado'],
    [820, 831, 'Wyoming'],
    [832, 838, 'Idaho'],
    [840, 847, 'Utah'],
    [850, 853, 'Arizona'],
    [855, 857, 'Arizona'],
    [859, 860, 'Arizona'],
    [863, 865, 'Arizona'],
    [870, 884, 'New Mexico'],
    [889, 898, 'Nevada'],
    [900, 961, 'California'],
    [967, 968, 'Hawaii'],
    [969, 969, 'Guam'],
    [970, 979, 'Oregon'],
    [980, 994, 'Washington'],
    [995, 999, 'Alaska']
  ];

  function lookupStateFromZip(zip) {
    var prefix = parseInt(zip.slice(0, 3), 10);

    if (Number.isNaN(prefix)) return null;

    for (var i = 0; i < ZIP_STATE_RANGES.length; i += 1) {
      var range = ZIP_STATE_RANGES[i];

      if (prefix >= range[0] && prefix <= range[1]) {
        return range[2];
      }
    }

    return null;
  }

  function readStoredZip() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function digitsOnly(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function normalizeZip(value) {
    var raw = String(value || '').trim();
    var digits = digitsOnly(raw).slice(0, 9);

    if (raw.indexOf('-') !== -1 && digits.length <= 5) {
      return digits + '-';
    }

    if (digits.length > 5) {
      return digits.slice(0, 5) + '-' + digits.slice(5);
    }

    return digits;
  }

  function isValidZip(value) {
    return /^\d{5}$|^\d{5}-\d{4}$/.test(String(value || '').trim());
  }

  function firstFive(value) {
    return digitsOnly(value).slice(0, 5);
  }

  function storeZip(zip) {
    try {
      if (isValidZip(zip)) window.localStorage.setItem(STORAGE_KEY, normalizeZip(zip));
    } catch (error) {
      // localStorage can be blocked in some privacy modes. Manual ZIP still works.
    }
  }

  function cleanZipValue(value) {
    return normalizeZip(value);
  }

  function extractZipFromAddress(address) {
    if (!address) return '';

    var postcode = address.postcode || address['ISO3166-2-lvl4'] || '';
    var match = String(postcode).match(/\b\d{5}\b/);

    return match ? match[0] : '';
  }

  function initZipOnlyShipping() {
    document.querySelectorAll('shipping-calculator.qls-zip-only-shipping').forEach(function (calculator) {
      if (calculator.dataset.qlsZipOnlyInit === 'true') return;
      calculator.dataset.qlsZipOnlyInit = 'true';

      var zipInput = calculator.querySelector('.js-zip-input');
      var countrySelect = calculator.querySelector('.js-country-select');
      var provinceSelect = calculator.querySelector('.js-province-select');
      var provinceWrap = calculator.querySelector('.js-province-container');
      var message = calculator.querySelector('.qls-zip-state-message');
      var button = calculator.querySelector('.qls-shipping-calc-button');
      var locateButton = calculator.querySelector('.qls-use-location-button');
      var locationStatus = calculator.querySelector('.qls-location-status');
      var savedAddressNotice = calculator.querySelector('.qls-saved-cart-address');
      var clearButton = calculator.querySelector('.qls-zip-clear-button');

      if (!zipInput || !countrySelect || !provinceSelect || !provinceWrap || !button) return;

      function cleanZip() {
        return cleanZipValue(zipInput.value);
      }

      function setMessage(text, isError) {
        if (!message) return;

        if (!text) {
          message.hidden = true;
          message.textContent = '';
          message.classList.remove('is-error');
          return;
        }

        message.hidden = false;
        message.textContent = text;
        message.classList.toggle('is-error', !!isError);
      }

      function setLocationStatus(text, isError) {
        if (!locationStatus) return;

        locationStatus.textContent = text || '';
        locationStatus.classList.toggle('is-error', !!isError);
      }

      function setSavedAddressNotice(show) {
        if (!savedAddressNotice) return;
        if (!show) {
          savedAddressNotice.hidden = true;
          savedAddressNotice.textContent = '';
          return;
        }

        var parts = [];
        var city = calculator.dataset.customerCity || '';
        var province = calculator.dataset.customerProvince || '';
        var zip = normalizeZip(calculator.dataset.customerZip || '');
        if (city) parts.push(city);
        if (province) parts.push(province);
        if (zip) parts.push(zip);
        savedAddressNotice.textContent = 'Using your saved address' + (parts.length ? ': ' + parts.join(', ') : '');
        savedAddressNotice.hidden = false;
      }

      function setButtonReady(isReady) {
        button.disabled = !isReady;
      }

      function updateClearButton() {
        if (clearButton) clearButton.hidden = !zipInput.value;
      }

      function setLocateLoading(isLoading) {
        if (!locateButton) return;

        locateButton.disabled = !!isLoading;
        locateButton.textContent = isLoading ? 'Checking location…' : 'Use my current location';
      }

      function revealProvinceFallback() {
        provinceWrap.classList.remove('qls-hidden-shipping-field');
        provinceWrap.hidden = false;
        setMessage('We could not detect your state automatically. Please select it below.', true);
      }

      function hideProvinceFallback() {
        provinceWrap.classList.add('qls-hidden-shipping-field');
        provinceWrap.hidden = true;
      }

      function findProvinceOption(stateName) {
        if (!stateName || !provinceSelect.options.length) return null;

        var target = stateName.trim().toLowerCase();

        return Array.from(provinceSelect.options).find(function (option) {
          return (
            option.text.trim().toLowerCase() === target ||
            option.value.trim().toLowerCase() === target
          );
        });
      }

      function ensureUnitedStatesSelected() {
        var matchedOption = Array.from(countrySelect.options).find(function (option) {
          return option.text.trim().toLowerCase() === 'united states' || option.value.trim().toLowerCase() === 'united states';
        });

        if (matchedOption && countrySelect.value !== matchedOption.value) {
          countrySelect.value = matchedOption.value;
          countrySelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      function applyProvince(stateName) {
        ensureUnitedStatesSelected();

        var matchedOption = findProvinceOption(stateName);
        if (!matchedOption) return false;

        provinceSelect.value = matchedOption.value;
        provinceSelect.dispatchEvent(new Event('change', { bubbles: true }));

        return provinceSelect.value === matchedOption.value;
      }

      function applyProvinceWhenReady(stateName, callback) {
        var attempts = 0;
        var maxAttempts = 20;

        function tryApply() {
          ensureUnitedStatesSelected();

          if (provinceSelect.options.length === 0 && attempts < maxAttempts) {
            attempts += 1;
            setTimeout(tryApply, 100);
            return;
          }

          var success = applyProvince(stateName);

          if (!success && attempts < maxAttempts) {
            attempts += 1;
            setTimeout(tryApply, 100);
          } else {
            callback(success);
          }
        }

        tryApply();
      }

      function resolveZip(options) {
        options = options || {};

        var zip = cleanZip();

        if (!isValidZip(zip)) {
          delete calculator.dataset.qlsZipReady;
          setButtonReady(false);
          setMessage('', false);
          hideProvinceFallback();

          if (typeof options.onResolved === 'function') {
            options.onResolved(false);
          }
          return;
        }

        zipInput.value = zip;
        storeZip(zip);

        // Correctly formatted ZIPs should look actionable immediately.
        setButtonReady(true);

        var stateName = lookupStateFromZip(firstFive(zip));

        if (!stateName) {
          revealProvinceFallback();
          setButtonReady(true);
          calculator.dataset.qlsZipReady = zip;

          if (typeof options.onResolved === 'function') {
            options.onResolved(true);
          }
          return;
        }

        setMessage('Detected: ' + stateName, false);

        applyProvinceWhenReady(stateName, function (success) {
          if (!success) {
            revealProvinceFallback();
            setButtonReady(true);
            calculator.dataset.qlsZipReady = zip;

            if (typeof options.onResolved === 'function') {
              options.onResolved(true);
            }
            return;
          }

          hideProvinceFallback();
          calculator.dataset.qlsZipReady = zip;
          setButtonReady(true);

          if (typeof options.onResolved === 'function') {
            options.onResolved(true);
          }
        });
      }

      async function reverseGeocodePosition(latitude, longitude) {
        var params = new URLSearchParams({
          format: 'jsonv2',
          lat: String(latitude),
          lon: String(longitude),
          zoom: '18',
          addressdetails: '1',
          'accept-language': 'en'
        });

        var response = await fetch(NOMINATIM_REVERSE_ENDPOINT + '?' + params.toString(), {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          },
          referrerPolicy: 'strict-origin-when-cross-origin'
        });

        if (!response.ok) {
          throw new Error('Location lookup failed.');
        }

        return response.json();
      }

      function handleLocationSuccess(position) {
        var coords = position && position.coords;

        if (!coords) {
          setLocateLoading(false);
          setLocationStatus('Please enter your ZIP code manually.', true);
          return;
        }

        reverseGeocodePosition(coords.latitude, coords.longitude)
          .then(function (data) {
            var address = data && data.address ? data.address : {};
            var countryCode = String(address.country_code || '').toLowerCase();

            if (countryCode && countryCode !== 'us') {
              setLocationStatus('We do not ship to this location.', true);
              return;
            }

            var zip = extractZipFromAddress(address);

            if (!zip) {
              setLocationStatus('Please enter your ZIP code manually.', true);
              return;
            }

            zipInput.value = zip;
            setLocationStatus('Current-location ZIP: ' + zip, false);

            resolveZip({
              onResolved: function (success) {
                if (success && !button.disabled) {
                  setTimeout(function () {
                    button.click();
                  }, 80);
                }
              }
            });
          })
          .catch(function () {
            setLocationStatus('Please enter your ZIP code manually.', true);
          })
          .finally(function () {
            setLocateLoading(false);
          });
      }

      function handleLocationError(error) {
        setLocateLoading(false);

        if (error && error.code === 1) {
          setLocationStatus('Please enter your ZIP code manually.', true);
          return;
        }

        if (error && error.code === 3) {
          setLocationStatus('Please enter your ZIP code manually.', true);
          return;
        }

        setLocationStatus('Please enter your ZIP code manually.', true);
      }

      zipInput.addEventListener('focus', function () { zipInput.dataset.qlsUserEditing = 'true'; });
      zipInput.addEventListener('blur', function () { window.setTimeout(function () { delete zipInput.dataset.qlsUserEditing; }, 350); });

      zipInput.addEventListener('input', function () {
        zipInput.dataset.qlsUserEditing = 'true';
        setSavedAddressNotice(false);
        delete calculator.dataset.qlsZipReady;
        setLocationStatus('', false);

        var inlineStatus = calculator.querySelector('.qls-delivery-inline-status');
        if (inlineStatus) {
          inlineStatus.hidden = true;
          inlineStatus.textContent = '';
          inlineStatus.classList.remove('is-success', 'is-error');
        }

        var ratesBox = calculator.querySelector('.js-rates');
        if (ratesBox) ratesBox.hidden = true;

        var enteredZip = cleanZip();
        zipInput.value = enteredZip;
        updateClearButton();
        setButtonReady(isValidZip(enteredZip));

        /* Wait for Check availability / Enter. Five digits may be the start of
           ZIP+4, so resolving here would commit too early and interrupt typing. */
        setMessage('', false);
        hideProvinceFallback();
      });

      if (clearButton) {
        clearButton.addEventListener('click', function () {
          zipInput.value = '';
          zipInput.dataset.qlsUserEditing = 'true';
          updateClearButton();
          setButtonReady(false);
          setMessage('', false);
          setLocationStatus('', false);
          delete calculator.dataset.qlsZipReady;
          try { window.localStorage.removeItem(STORAGE_KEY); } catch (error) {}
          window.dispatchEvent(new CustomEvent('qls:delivery-check-cleared', { detail: { source: calculator } }));
          zipInput.focus({ preventScroll: true });
        });
      }

      zipInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          if (!button.disabled) {
            button.click();
          }
          event.preventDefault();
        }
      });

      button.addEventListener('click', function (event) {
        setLocationStatus('', false);

        var inlineStatus = calculator.querySelector('.qls-delivery-inline-status');
        if (inlineStatus) {
          inlineStatus.hidden = true;
          inlineStatus.textContent = '';
          inlineStatus.classList.remove('is-success', 'is-error');
        }

        var zip = cleanZip();

        if (!isValidZip(zip)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setMessage('Please enter 5 digits, ZIP+4, or 9 digits without the hyphen.', true);
          setButtonReady(false);
          return;
        }

        zipInput.value = zip;
        storeZip(zip);

        if (calculator.dataset.qlsZipReady !== zip) {
          event.preventDefault();
          event.stopImmediatePropagation();

          if (calculator.dataset.qlsZipAutoSubmitting === 'true') return;
          calculator.dataset.qlsZipAutoSubmitting = 'true';

          resolveZip({
            onResolved: function (success) {
              delete calculator.dataset.qlsZipAutoSubmitting;

              if (success && calculator.dataset.qlsZipReady === zip) {
                window.setTimeout(function () {
                  button.click();
                }, 0);
              }
            }
          });
        }
      }, true);

      if (locateButton) {
        locateButton.addEventListener('click', function () {
          setLocationStatus('', false);

          var inlineStatus = calculator.querySelector('.qls-delivery-inline-status');
          if (inlineStatus) {
            inlineStatus.hidden = true;
            inlineStatus.textContent = '';
            inlineStatus.classList.remove('is-success', 'is-error');
          }

          var ratesBox = calculator.querySelector('.js-rates');
          if (ratesBox) ratesBox.hidden = true;

          if (!window.isSecureContext) {
            setLocationStatus('Please enter your ZIP code manually.', true);
            return;
          }

          if (!navigator.geolocation) {
            setLocationStatus('Please enter your ZIP code manually.', true);
            return;
          }

          setLocateLoading(true);
          setLocationStatus('Your browser may ask for permission.', false);

          navigator.geolocation.getCurrentPosition(handleLocationSuccess, handleLocationError, {
            enableHighAccuracy: false,
            timeout: 10000,
            maximumAge: 600000
          });
        });
      }

      ensureUnitedStatesSelected();

      function handleSharedZipUpdate(event) {
        var detail = event.detail || {};
        var incoming = detail.result && detail.result.zip ? detail.result.zip : detail.zip;
        incoming = cleanZipValue(incoming || '');
        if (!isValidZip(incoming) || incoming === cleanZip()) return;
        if (document.activeElement === zipInput || zipInput.dataset.qlsUserEditing === 'true') return;
        zipInput.value = incoming;
        setSavedAddressNotice(false);
        setLocationStatus('', false);
        resolveZip();
      }
      window.addEventListener('qls:delivery-check-updated', handleSharedZipUpdate);
      window.addEventListener('qls:delivery-check-cleared', function () {
        if (document.activeElement === zipInput || zipInput.dataset.qlsUserEditing === 'true') return;
        zipInput.value = '';
        updateClearButton();
        setButtonReady(false);
        setMessage('', false);
        setLocationStatus('', false);
        delete calculator.dataset.qlsZipReady;
      });

      var storedZip = cleanZipValue(readStoredZip());
      var customerZip = normalizeZip(calculator.dataset.customerZip || '');
      var customerCountry = String(calculator.dataset.customerCountry || '').toUpperCase();

      if (isValidZip(storedZip)) {
        zipInput.value = storedZip;
        setLocationStatus('Saved ZIP: ' + storedZip, false);
      } else if (isValidZip(customerZip) && (!customerCountry || customerCountry === 'US' || customerCountry === 'USA')) {
        zipInput.value = customerZip;
        setSavedAddressNotice(true);
      }

      updateClearButton();
      if (isValidZip(cleanZip())) resolveZip();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZipOnlyShipping);
  } else {
    initZipOnlyShipping();
  }

  [
    'dispatch:cart-drawer:refresh',
    'cart:updated',
    'on:cart-drawer:after-open',
    'on:line-item:change',
    'shopify:section:load'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      window.setTimeout(initZipOnlyShipping, 0);
    });
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      var shouldInit = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1 && (
            node.matches('shipping-calculator') ||
            node.querySelector('shipping-calculator')
          );
        });
      });

      if (shouldInit) {
        initZipOnlyShipping();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
